// Versión de la plataforma que está corriendo.
//   - version: semver de package.json (REACT_APP_VERSION, expandida en .env).
//   - commit / buildDate: los genera scripts/build-info.js al compilar.
//   - env: REACT_APP_ENV que fija cada script (production / staging); vacío en dev.
import buildInfo from 'buildInfo.json';

export const APP_VERSION = process.env.REACT_APP_VERSION || '0.0.0';
export const APP_COMMIT = buildInfo.commit;
export const APP_BUILD_DATE = buildInfo.buildDate;
export const APP_ENV = process.env.REACT_APP_ENV || (process.env.NODE_ENV === 'production' ? 'production' : 'development');

/** "v3.0.0 (a1b2c3d)", para reportes y logs. */
export const APP_VERSION_LABEL = `v${APP_VERSION} (${APP_COMMIT})`;
